import type { ThemeOptions } from "@mui/material/styles";

const KANZ = '"Kanz Al Marjaan"';

function hasKanzInStack(fontFamily: string): boolean {
  return fontFamily.includes("Kanz Al Marjaan");
}

/**
 * Prepends {@link KANZ} to `typography.fontFamily` so Arabic-script text uses Kanz when the
 * global `@font-face` applies (see `kanzArabicFontFace.css`). Safe to call after tenant theme merge.
 */
export function withArabicDisplayFont(theme: ThemeOptions): ThemeOptions {
  const typo = theme.typography;
  if (typeof typo === "function") {
    return theme;
  }

  const existing = typo?.fontFamily;
  if (typeof existing === "string" && existing.trim() !== "") {
    if (hasKanzInStack(existing)) {
      return theme;
    }
    return {
      ...theme,
      typography: {
        ...typo,
        fontFamily: `${KANZ}, ${existing}`,
      },
    };
  }
  return {
    ...theme,
    typography: {
      ...typo,
      fontFamily: `${KANZ}, Geist, "Source Sans Pro", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    },
  };
}
